import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { inbound: () => import('./InboundPage.vue') },
} satisfies FeatureRoutes
